import React from 'react';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { Head } from './components/Head';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Projects } from './components/Projects';
import { TechNews } from './components/TechNews';
import { Contact } from './components/Contact';
import { Clients } from './components/Clients';
import Founder from './components/Founder';
import { Footer } from './components/Footer';

function AppContent() {
  const { data, isRTL } = useLanguage();

  return (
    <div className="min-h-screen" dir={isRTL ? 'rtl' : 'ltr'}>
      <Head />
      <Navbar />
      {data.slideshow.active && <Hero />}
      {data.ourservice.active && <Services />}
      {data.ourprojects.active && <Projects />}
      {data.technews.active && <TechNews />}
      {data.ourclients.active && <Clients />}
      <Founder />
      {data.contactus.active && <Contact />}
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}